"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationPreferenceSection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const notification_center_models_1 = require("@forto-dev/notification-center-models");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const lodash_es_1 = require("lodash-es");
const types_1 = require("../../../features/NotificationsSettings/types");
const translations_1 = require("../../../features/NotificationsSettings/types/translations");
const NotificationPreferenceSubSection_1 = require("./NotificationPreferenceSubSection");
const trackingIds = {
    instantSelectAllCheckBox: 'notification_settings-preferences-select_all_instant_checkbox',
    dailyDigestSelectAllCheckBox: 'notification_settings-preferences-select_all_daily_digest_checkbox',
};
const useStyles = (0, silhouette_core_1.makeStyles)({
    container: {
        overflow: 'auto',
    },
    checkbox: {
        minWidth: 160,
    },
    allEnableOptionItem: {
        textAlign: 'right',
    },
});
const getSubSectionData = (data) => {
    return data.reduce((acc, preference) => {
        const subCategory = preference?.subCategory || '';
        acc[subCategory] = [...(acc[subCategory] || []), preference];
        return acc;
    }, {});
};
const NotificationPreferenceSection = ({ sectionData, state, disableChanges, updatePreferences, }) => {
    const classes = useStyles();
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    if (!state)
        return null;
    if (sectionData.preferences.flatMap((preference) => (0, types_1.getReferences)(preference)).some((reference) => !state[reference])) {
        throw new Error('Missing state for some preferences');
    }
    const combinedPreferenceState = sectionData.preferences.flatMap((preference) => {
        const referenceArray = (0, types_1.getReferences)(preference);
        return referenceArray.map((reference) => ({
            reference,
            ...state[reference],
            visibleChannels: preference.visibleChannels,
        }));
    });
    const onlyEnabled = combinedPreferenceState.filter((preference) => {
        if (!preference.visibleChannels || (0, lodash_es_1.includes)(preference.visibleChannels, notification_center_models_1.NotificationPreferenceOptionsEnum.web)) {
            return preference.web;
        }
        return true;
    });
    const isAllSelected = (channel) => {
        const allSelected = onlyEnabled.length
            ? onlyEnabled.filter((preference) => {
                if (!preference.visibleChannels) {
                    return true;
                }
                return (0, lodash_es_1.includes)(preference.visibleChannels, channel);
            })
            : [];
        return (!!allSelected.length &&
            allSelected.every((preference) => {
                if (preference.visibleChannels) {
                    return (0, lodash_es_1.includes)(preference.visibleChannels, channel) && preference[channel];
                }
                return preference[channel];
            }));
    };
    const isAllInstant = isAllSelected(notification_center_models_1.NotificationPreferenceOptionsEnum.instantEmail);
    const isAllDigest = isAllSelected(notification_center_models_1.NotificationPreferenceOptionsEnum.digestEmail);
    const subSectionData = getSubSectionData(sectionData.preferences);
    function getOptionsToUpdate(channel, value) {
        return combinedPreferenceState
            .filter((preference) => {
            if (!preference.visibleChannels ||
                (0, lodash_es_1.includes)(preference.visibleChannels, notification_center_models_1.NotificationPreferenceOptionsEnum.web)) {
                return preference.web;
            }
            return preference.visibleChannels && (0, lodash_es_1.includes)(preference.visibleChannels, channel);
        })
            .map((preference) => {
            return {
                ...(0, lodash_es_1.omit)(preference, ['visibleChannels', 'default']),
                ...{ [channel]: value },
            };
        });
    }
    const changeInstant = () => {
        const optionsToUpdate = getOptionsToUpdate(notification_center_models_1.NotificationPreferenceOptionsEnum.instantEmail, !isAllInstant);
        updatePreferences(optionsToUpdate);
    };
    const changeDigest = () => {
        const optionsToUpdate = getOptionsToUpdate(notification_center_models_1.NotificationPreferenceOptionsEnum.digestEmail, !isAllDigest);
        updatePreferences(optionsToUpdate);
    };
    return ((0, jsx_runtime_1.jsxs)(silhouette_core_1.Box, { px: 4, className: classes.container, children: [(0, jsx_runtime_1.jsx)(silhouette_core_1.Box, { py: 2.5, children: (0, jsx_runtime_1.jsx)(silhouette_core_1.FormGroup, { children: (0, jsx_runtime_1.jsx)(silhouette_core_1.Grid, { container: true, alignItems: "center", justifyContent: "flex-end", children: (0, jsx_runtime_1.jsx)(silhouette_core_1.Grid, { xs: 5, children: (0, jsx_runtime_1.jsxs)(silhouette_core_1.Grid, { container: true, alignItems: "center", justifyContent: "flex-end", children: [(0, jsx_runtime_1.jsx)(silhouette_core_1.Grid, { xs: 7, className: classes.allEnableOptionItem, children: (0, jsx_runtime_1.jsx)(silhouette_core_1.FormControlLabel, { className: classes.checkbox, control: (0, jsx_runtime_1.jsx)(silhouette_core_1.Checkbox, { disabled: disableChanges, name: "selectAllInstantEmail", checked: isAllInstant, color: "primary", onChange: changeInstant, inputProps: {
                                                    'data-tracking-id': trackingIds.instantSelectAllCheckBox,
                                                } }), label: translate(translations_1.checkboxTranslations.selectAll) }) }), (0, jsx_runtime_1.jsx)(silhouette_core_1.Grid, { xs: 5, className: classes.allEnableOptionItem, children: (0, jsx_runtime_1.jsx)(silhouette_core_1.FormControlLabel, { className: classes.checkbox, control: (0, jsx_runtime_1.jsx)(silhouette_core_1.Checkbox, { disabled: disableChanges, name: "selectAllDigestEmail", checked: isAllDigest, color: "primary", onChange: changeDigest, inputProps: {
                                                    'data-tracking-id': trackingIds.dailyDigestSelectAllCheckBox,
                                                } }), label: translate(translations_1.checkboxTranslations.selectAll), color: "primary" }) })] }) }) }) }) }), Object.keys(subSectionData).map((section) => {
                return ((0, jsx_runtime_1.jsx)(NotificationPreferenceSubSection_1.NotificationPreferenceSubSection, { data: subSectionData[section], state: state, updatePreferences: updatePreferences, disableChanges: disableChanges }, section));
            })] }));
};
exports.NotificationPreferenceSection = NotificationPreferenceSection;
//# sourceMappingURL=NotificationPreferenceSection.js.map